import React, { useContext, useState } from 'react';

import useTranslate from '../../../../../common/hooks/useTranslate';
import { useDispatch } from 'react-redux';

import { setPin, removePin } from '../../../../services/documentsService';
import { downloadDoc } from '../../../../services/documentsService';

import DocsCtx from '../../../../../context/docsContext/docsCtx';
import { POPUP } from '../../../../../redux/types';

import { IDocumentsCell } from '../../../types/IDocumentsCell';

import Icon from '../../../../ui/icon/icon';
import Pin from '../../../../ui/button/pin/pin';
import LoadingCell from '../../../../ui/table/cells/loadingCell/loadingCell';

import './actionsCell.scss';

const ActionsCell: React.FC<IDocumentsCell> = ({
                                                 dataItem,
                                                 rowType,
                                                 treelist,
                                                 isDocNumberShown,
                                                 onCheck,
                                                 onUncheck,
                                                 style,
                                                 className,
                                                 handleSliceDownload,
                                                 width,
                                                 multipleDownload,
                                               }) => {
  const [pinned, setPinned] = useState<boolean | undefined>(dataItem.isPinned);

  const { t } = useTranslate();
  const docsCtx = useContext(DocsCtx);
  const dispatch = useDispatch();

  let displayDocNumber = '';

  if (rowType === 'groupHeader') {
    return null;
  }

  if (dataItem['documentId'] === undefined && treelist) {
    let docLabel = '';
    let folderLabel = '';
    if (dataItem.children) {
      docLabel = dataItem.children.length > 1 ? t('DOCUMENTS_TABLE.LABEL_DOCUMENTS') : t('DOCUMENTS_TABLE.LABEL_DOCUMENT');
      folderLabel = dataItem.children.length > 1 ? t('DOCUMENTS_TABLE.LABEL_FOLDERS') : t('DOCUMENTS_TABLE.LABEL_FOLDER');
    }

    if (!isDocNumberShown) {
      displayDocNumber = `treelist-header-cell no-display`;
    } else {
      displayDocNumber = `treelist-header-cell ${dataItem && dataItem.children && dataItem.children[0] && !dataItem.children[0]['documentId'] && 'folder-header-cell'}`;
    }
    return (
      <td style={style} className={className}>
        <div className={displayDocNumber}>
          {dataItem.children &&
            <>
              {/*{dataItem.children[0]['documentId'] && <Icon className='pointer download-icon' name={'far fa-file-zipper'}*/}
              {/*                                             onClick={() => handleSliceDownload(dataItem.children)} />}*/}
              <span
                className='label'>{`${dataItem.children.length} ${dataItem.children[0]['documentId'] ? docLabel : folderLabel}`}</span>
            </>
          }
        </div>
      </td>
    );
  }

  if (dataItem['documentId'] === undefined) return <LoadingCell />;

  const isCheckedDocId = docsCtx.selectedItemsDocIds && docsCtx.selectedItemsDocIds.indexOf(dataItem['documentId']);
  const isCheckedId = docsCtx.selectedItemsIds && docsCtx.selectedItemsIds.indexOf(dataItem['id']);

  const handleCheck = () => {
    if (isCheckedId !== -1) {
      onUncheck(dataItem.documentId, dataItem.id);
    } else if (isCheckedId === -1 && isCheckedDocId !== -1) {
      onCheck(dataItem.documentId, dataItem.id);
    } else {
      onCheck(dataItem.documentId, dataItem.id);
    }
  };

  const handlePinClick = () => {
    if (pinned === false) {
      setPin(parseInt(dataItem.id)).then(() => {
        setPinned(true);
      }).catch((err) => dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message }));
    } else if (pinned === true) {
      removePin(parseInt(dataItem.id)).then(() => {
        setPinned(false);
      }).catch((err) => dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message }));
    }
  };

  const handleDownload = () => {
    downloadDoc(dataItem).catch((err) => dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message }));
  };

  return (
    <td className='action-cell-td' style={{ width: width }}>
      <div className='actions-cell'>
        <Icon className='actions-cell-icon pointer'
              name={`${isCheckedId !== -1 ? 'fas fa-check-square' : 'far fa-square'}`}
              onClick={handleCheck} />
        <Icon className='actions-cell-icon pointer' name={'far fa-file-download'}
              disabled={multipleDownload && isCheckedId !== -1} onClick={handleDownload} />
        <Pin isPinned={pinned} clickHandler={handlePinClick} className={'actions-cell-icon pointer'} />
      </div>
    </td>
  );
};

export default ActionsCell;
